import Changes  from '/components/changes'

import { withChanges } from './queries'

export default withChanges Changes
